import React, { useCallback, useContext, useMemo } from 'react'
import LineShieldCheckIcon from 'LuxKit/Icons/line/LineShieldCheckIcon'
import OrderUpsellTileWithTracking from 'components/Common/OrderUpsellTileWithTracking'
import { getRemainingSecondsToPostPurchaseInsuranceBookingProtection } from 'lib/order/orderInsuranceBookingProtectionUtils'
import ModalContext from 'contexts/ModalContext'
import RemainingTimeModal from 'components/Insurance/RemainingTimeModal'

interface Props {
  insuranceBookingProtectioUpsellData: App.InsuranceUpsell;
  onClick: () => void;
  order: App.Order,
  variant?: 'compact' | 'default';
  onDismiss?: () => void;
}

function InsuranceBookingProtectionUpsellTile(props: Props) {
  const {
    insuranceBookingProtectioUpsellData,
    variant = 'default',
    onDismiss,
    order,
    onClick,
  } = props

  const showModal = useContext(ModalContext)

  const {
    fetchingQuotes,
    fetchingLuxPlusSubscription,
    cheapestQuotePrice,
    cheapestQuoteLuxPlusPrice,
    isEnabledLuxPlusDiscountedInsurance,
  } = insuranceBookingProtectioUpsellData

  const remainingTime = useMemo(() => {
    const totalSeconds = getRemainingSecondsToPostPurchaseInsuranceBookingProtection(order)
    const remainingHours = Math.floor(totalSeconds / 3600)
    const remainingMinutes = Math.floor(totalSeconds / 60)
    return {
      hours: remainingHours,
      minutes: remainingMinutes,
    }
  }, [order])

  const alertText = useMemo(() => {
    if (remainingTime.hours >= 1) {
      return `Available for next ${remainingTime.hours}h`
    } else if (remainingTime.minutes > 0) {
      return `Available for next ${remainingTime.minutes}min`
    }
  }, [remainingTime])

  const alertClickHandler = useCallback(() => {
    showModal(<RemainingTimeModal remainingTime={remainingTime} />)
  }, [showModal, remainingTime])

  return <OrderUpsellTileWithTracking
    title="Cancellation protection"
    description="Receive a 100% refund if you need to cancel for unforeseen events."
    price={cheapestQuotePrice}
    luxPlusPrice={cheapestQuoteLuxPlusPrice}
    priceUnit="person"
    isPriceLoading={fetchingQuotes || (isEnabledLuxPlusDiscountedInsurance && fetchingLuxPlusSubscription)}
    currencyFormat="dynamicDollar"
    IconComponent={LineShieldCheckIcon}
    analyticsSubject="cfmr"
    className="insurance-upsell-tile"
    variant={variant}
    onDismissClick={onDismiss}
    alertText={alertText}
    onAlertClick={alertClickHandler}
    onClick={onClick}
  />
}

export default InsuranceBookingProtectionUpsellTile
